import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';

import { AlertSnackbarContext } from '../../../components/snackbars';
import Api from '../../api/api';

export const deleteTopic = async (topicId: string) => {
  const [response, bodyOrError] = await Api.delete(`topics/${topicId}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeleteTopic = () => {
  const queryClient = useQueryClient();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation(
    'deleteTopic',
    (data: { topicId: string }) => {
      return deleteTopic(data.topicId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['topics']);
        setAlertSnackbar({
          message: 'Topic deleted successfully',
          severity: 'success',
          vertical: 'top',
        });
      },
      onError: (error) => {
        setAlertSnackbar({
          message: (error as Error)?.message || 'Failed to delete topic',
          severity: 'error',
          vertical: 'top',
        });
      },
    },
  );
};
